import { Vector3 } from 'three';
import { MovementDataDTO } from '../DTOs/MovementDataDTO';
import { WallMovementConstraint } from './WallPositionConstraint';
import { WallMovementConstraintDTO } from '../DTOs/WallPositionConstraintDTO';

export class MovementData {
  public static fromDTO(movementDataDTO: MovementDataDTO) {
    let linkVector: Vector3;
    let productOffset = 0;

    if (
      movementDataDTO.linkVector === undefined || // Checks if linkVector itself is not defined
      movementDataDTO.linkVector.length < 3 || // Checks if linkVector does not have 3 elements
      movementDataDTO.linkVector[0] === undefined || // Checks if the first element is undefined
      movementDataDTO.linkVector[1] === undefined || // Checks if the second element is undefined
      movementDataDTO.linkVector[2] === undefined // Checks if the third element is undefined
    ) {
      linkVector = new Vector3(0, 0, 1);
    } else {
      linkVector = new Vector3(
        movementDataDTO.linkVector[0],
        movementDataDTO.linkVector[1],
        movementDataDTO.linkVector[2],
      );
    }

    if (movementDataDTO.productOffset) {
      productOffset = movementDataDTO.productOffset;
    }

    const wallMovementConstraints: WallMovementConstraint[] = [];

    if (!movementDataDTO.wallMovementConstraints) {
      movementDataDTO.wallMovementConstraints = WallMovementConstraintDTO.defaultValue;
      movementDataDTO.wallMovementConstraints.forEach((constraint) => {
        constraint.linkVector = linkVector.toArray();
      });
    } else {
      movementDataDTO.wallMovementConstraints.forEach((constraint) => {
        if (!constraint.linkVector || constraint.linkVector.length === 0) {
          constraint.linkVector = linkVector.toArray();
        }
      });
    }

    for (const wallMovementConstraintDTO of movementDataDTO.wallMovementConstraints) {
      wallMovementConstraints.push(WallMovementConstraint.fromDTO(wallMovementConstraintDTO));
    }

    return new MovementData(productOffset, wallMovementConstraints, linkVector);
  }

  private _productOffset: number;
  private _wallPositionConstraints: WallMovementConstraint[];

  private _linkVector: Vector3;

  constructor(productOffset: number, wallPositionConstraints: WallMovementConstraint[], linkVector: Vector3) {
    this._productOffset = productOffset;
    this._wallPositionConstraints = wallPositionConstraints;
    this._linkVector = linkVector;
  }

  // Optional: Add getter methods to access the private properties if needed
  public get productOffset(): number {
    return this._productOffset;
  }

  public get linkVector() {
    return this._linkVector;
  }

  public get wallPositionConstraints(): WallMovementConstraint[] {
    return this._wallPositionConstraints;
  }

  public toDTO() {
    return new MovementDataDTO(
      this.productOffset,
      this._wallPositionConstraints.map((wallPositionConstraint) => wallPositionConstraint.toDTO()),
      this._linkVector ? [this._linkVector.x, this._linkVector.y, this._linkVector.z] : [0, 0, 0],
    );
  }
}
